import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Breadcrumbs from "../breadcrumbs";
import { ActionButton } from "../buttons";
import { BellIcon, SettingsIcon } from "../../icons";
import SearchField from "../search";
import { actions, RootState } from "../../state/reducer";

export const Header = () => {
  const State = useSelector((state: RootState) => state);
  const dispatch = useDispatch();
  const isNotifyOpen = State.notifyOpen;
  const notifyCount = State.notifications.filter((item) => !item.read).length;

  const notifyClickAction = () => {
    dispatch(actions.notifyOpen(!isNotifyOpen));
  };

  const settingsClickAction = () => {
    document.location.href = "/profile/edit";
  };

  // ${State.menuHidden ? " sided" : ""}
  return (
    <div className="header">
      <div className="headerInner smallInner topPanelInner sided">
        <Breadcrumbs />
        <div className="flex topBtnBlock">
          <ActionButton
            classNames={isNotifyOpen ? ["active"] : []}
            icon={<BellIcon width={20} height={20} />}
            action={notifyClickAction}
          />
          {notifyCount > 0 && (
            <span
              className="unreadMark"
              style={{ position: "absolute", left: 36, top: 0 }}
            />
          )}
          <ActionButton
            icon={<SettingsIcon width={20} height={20} />}
            action={settingsClickAction}
          />
        </div>
      </div>
    </div>
  );
};
